import axios from "axios";
import {
    fsShareSession,
    fsStoreSession,
    usingFirestore,
} from "../../components/utils/firestoreData";
import { escapeHtml } from "../../components/utils/Utils";
import { myzip } from "../../components/utils/zip";

// ── Runtime-switchable API URL ────────────────────────────────────────────────
// Default: cloud API from env var.
// Switch to local relay at runtime via setApiSource("local") — persisted in
// localStorage so the choice survives page refreshes.
export const CLOUD_API_URL = process.env.REACT_APP_VBLIVE_API_URL;
const kApiSource = "vblive_api_source"; // localStorage key
const kLocalRelayHost = "vblive_local_relay_host"; // localStorage key

// The relay's LAN IP/hostname CANNOT be reliably auto-detected: VBLive is
// normally opened from the cloud-hosted deployment (Vercel), which has NO
// relationship to whichever machine on the operator's LAN is running the
// local relay — using `window.location.hostname` in that case pointed the
// "Local" API source at the cloud domain itself (or, if VBLive happened to be
// opened from the SAME machine as the relay, "localhost"), silently
// returning zero sessions either way. So the relay host is a small
// user-editable setting (see Live.jsx), defaulting to "localhost" for the
// common same-machine case.
export function getLocalRelayHost() {
  return localStorage.getItem(kLocalRelayHost) || "localhost";
}
export function setLocalRelayHost(host) {
  localStorage.setItem(kLocalRelayHost, host || "");
}
// LOCAL_API_URL must be computed fresh on every call (not a static constant)
// so editing the relay host takes effect immediately, without a page reload.
export function getLocalApiUrl() {
  return `http://${getLocalRelayHost()}:8080/api`;
}

export function getApiUrl() {
  const src = localStorage.getItem(kApiSource);
  return src === "local" ? getLocalApiUrl() : CLOUD_API_URL;
}
export function getApiSource() {
  return localStorage.getItem(kApiSource) || "cloud";
}
export function setApiSource(src) { // "cloud" | "local"
  localStorage.setItem(kApiSource, src);
}

const vbliveapi = axios.create({ baseURL: CLOUD_API_URL });

export const getSessions = async (appName, serverName) => {
  const params = new URLSearchParams({
    appName: appName,
    serverName: serverName,
  });

  vbliveapi.defaults.withCredentials = true;

  const response = await vbliveapi.get(
    `Session/GetSessionInfoInServerForApp?${params}`
  );
  var sessionData = { sessions: response.data, appName: appName };
  return sessionData;
};

export const getSessionsForServer = async (serverName) => {
  // const params = new URLSearchParams({
  //   serverName: serverName,
  // });

  // vbliveapi.defaults.withCredentials = true;

  // const response = await vbliveapi.get(
  //   `Session/GetSessionsForServer?${params}`
  // );
  // var sessionData = { sessions: response.data, serveName: serverName };
  // return sessionData;

  const qs = require("qs");
  let data = qs.stringify({});

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${getApiUrl()}/Session/GetSessionsForServer/${serverName}`,
    headers: {},
    data: data,
  };

  var sessionData = { sessions: [], serverName: serverName };
  await axios
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      sessionData = { sessions: response.data, serverName: serverName };
    })
    .catch((error) => {
      console.log(error);
    });
  return sessionData;
};

export const getSessionInfoForServer = async (serverName) => {
  // const params = new URLSearchParams({
  //   serverName: serverName,
  // });

  // vbliveapi.defaults.withCredentials = true;

  // const response = await vbliveapi.get(
  //   `Session/GetSessionInfoForServer?${params}`
  // );
  // var sessionData = { sessions: response.data };
  // return sessionData;
  const qs = require("qs");
  let data = qs.stringify({});

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${getApiUrl()}/Session/GetSessionInfoForServer/${serverName}`,
    headers: {},
    data: data,
  };

  var sessionData = { sessions: [], serverName: serverName };
  await axios
    .request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      sessionData = { sessions: response.data, serverName: serverName };
    })
    .catch((error) => {
      console.log(error);
    });
  return sessionData;
};

export const getSession = async (sessionId) => {
  // const params = new URLSearchParams({
  //   sessionId: sessionId,
  // });

  // vbliveapi.defaults.withCredentials = true;

  // const response = await vbliveapi.get(`Session/GetSessionsById?${params}`);
  // return response.data[0];
  const qs = require("qs");
  let data = qs.stringify({});

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${getApiUrl()}/Session/GetSessionsById/${sessionId}`,
    headers: {},
    data: data,
  };

  var sessionData = {};
  await axios
    .request(config)
    .then((response) => {
      // console.log(JSON.stringify(response.data));
      sessionData = response.data[0];
    })
    .catch((error) => {
      console.log(error);
    });
  return sessionData;
};

export const deleteSession = async (sessionId) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: getApiSource() === "cloud"
      ? `${getApiUrl()}/Session/DeleteSession/${sessionId}`
      : `${getApiUrl()}/Session/DeleteSession?sessionId=${sessionId}`,
    headers: {},
  };

  var success = false;
  await axios
    .request(config)
    .then(() => {
      success = true;
    })
    .catch((error) => {
      console.log(error);
    });
  return success;
};

export const getLatestStats = async (sessionId, lastTime) => {
  // const params = new URLSearchParams({
  //   sessionId: sessionId,
  //   lastTime: lastTime,
  // });

  // vbliveapi.defaults.withCredentials = true;

  // const response = await vbliveapi.get(`Session/GetLatestStats?${params}`);
  // return response.data;
  const qs = require("qs");
  let data = qs.stringify({});

  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${getApiUrl()}/Session/GetLatestStats/${sessionId}/${lastTime}`,
    headers: {},
    data: data,
  };

  var lateststats = null;
  await axios
    .request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      lateststats = response.data;
    })
    .catch((error) => {
      console.log(error);
    });
  return lateststats;
};

export const storeSession = async (match, currentUser) => {
  if (usingFirestore()) {
    return await fsStoreSession(match, currentUser);
  }
  const teamAName = escapeHtml(match.teamA.Name);
  const teamBName = escapeHtml(match.teamB.Name);
  const tournamentName = match.tournamentName
    ? match.tournamentName.length === 0
      ? "?"
      : escapeHtml(match.tournamentName)
    : "?";
  const desc = teamAName + " vs " + teamBName;
  var seconds = 0;
  var dt = match.TrainingDate;
  try {
    seconds = match.TrainingDate.getTime() / 1000;
  } catch (error) {
    dt = new Date(match.TrainingDate);
    seconds = dt.getTime() / 1000;
  }
  const voffset = match.videoOffset ? match.videoOffset : -1;
  const vstarttime = match.videoStartTimeSeconds
    ? match.videoStartTimeSeconds
    : -1;
  const vurl = match.videoOnlineUrl ? match.videoOnlineUrl : "?";
  var sc = "";
  for (var game of match.sets) {
    if (sc.length > 0) sc += ", ";
    sc += game.HomeScore + "-" + game.AwayScore;
  }
  const buffer = myzip(match.buffer);

  const qs = require("qs");
  let dataobj = {
    appName: "VBLive",
    serverName: currentUser.email,
    // Stable per-match identity (see DVWFile.js's generateMatch /
    // deterministicUUIDFromString) -- same for every re-save of this exact
    // match, but NOT globally unique across different owners (two users
    // importing the same DVW file get the same guid). The backend must
    // upsert on (serverName, sessionId), not on content fields alone, or
    // two different users importing the same match will overwrite each
    // other's saved session.
    sessionId: match.guid,
    scores: sc,
    videoOnlineUrl: vurl,
    teamA: teamAName,
    teamB: teamBName,
    sessionDateTimeInSeconds: seconds,
    tournament: tournamentName,
    videoStartTimeSeconds: vstarttime,
    videoOffset: voffset,
    sessionDateString: dt.toLocaleDateString(),
    description: desc,
    stats: buffer,
  };
  let data = qs.stringify(dataobj);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${getApiUrl()}/Session/StoreSession`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  };

  var ret = 0;
  await axios
    .request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      ret = response.data;
    })
    .catch((error) => {
      console.log(error);
      ret = 0;
    });
  return ret;
};

export const shareSession = async (match) => {
  if (usingFirestore()) {
    return await fsShareSession(match);
  }
  const qs = require("qs");
  let data = qs.stringify({
    shareStatus: match.shareStatus,
    shareUsers: match.shareUsers.length > 0 ? match.shareUsers : "?",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: getApiSource() === "cloud"
      ? `${getApiUrl()}/Session/ShareSession/${match.id}`
      : `${getApiUrl()}/Session/ShareSession?matchId=${match.id}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  };

  var ret = false;
  await axios
    .request(config)
    .then((response) => {
      ret = response.data;
      if (!ret) {
        // The request succeeded (2xx) but the server's own body signalled
        // failure — log the raw response so the actual backend contract is
        // visible, since "falsy" alone doesn't say whether it's `false`,
        // `0`, an empty string, or an error payload shaped differently.
        console.warn(
          "shareSession: server returned a falsy result for match",
          match.id,
          "status:", response.status,
          "data:", response.data,
          "url:", config.url,
        );
      }
    })
    .catch((error) => {
      // Previously swallowed with no trace at all, so a failed share looked
      // identical whether caused by a network error, a bad matchId, or a
      // server error — log it so the real cause is visible next time.
      console.error("shareSession failed for match", match.id, error);
      ret = false;
    });
  return ret;
};

export const storePlaylist = async (playlist) => {
  const qs = require("qs");
  let data = qs.stringify({
    description: escapeHtml(playlist.description),
    comments: escapeHtml(playlist.comments),
    playlists: playlist.playlists,
    appName: playlist.appName,
    serverName: playlist.serverName,
    dateInSeconds: Number.parseInt(playlist.dateInSeconds),
    tags: escapeHtml(playlist.tags),
    shareStatus: playlist.shareStatus,
    shareUsers: playlist.shareUsers.length > 0 ? playlist.shareUsers : "?",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: getApiSource() === "cloud"
      ? `${getApiUrl()}/Session/StorePlayList/${playlist.id}`
      : `${getApiUrl()}/Session/StorePlayList?plId=${playlist.id}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  };

  var newplId = -1;
  await axios
    .request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      newplId = response.data;
    })
    .catch((error) => {
      console.log(error);
    });
  return newplId[0].id ? newplId[0].id : newplId;
};

export const sharePlaylist = async (playlist) => {
  const qs = require("qs");
  let data = qs.stringify({
    shareStatus: playlist.shareStatus,
    shareUsers: playlist.shareUsers.length > 0 ? playlist.shareUsers : "?",
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: getApiSource() === "cloud"
      ? `${getApiUrl()}/Session/SharePlaylist/${playlist.id}`
      : `${getApiUrl()}/Session/SharePlaylist?playlistId=${playlist.id}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: data,
  };

  await axios
    .request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
    })
    .catch((error) => {
      console.log(error);
    });
};
